<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <div class="content">
      <el-form
        ref="form"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        :rules="rules"
        @submit.native.prevent
        class="form-wrap"
      >
        <el-form-item label="选择账号:" prop="userName">
          <el-input
            v-model="formData.userName"
            disabled
            placeholder="必选"
            class="form-item__input"
          ></el-input>
          <el-button @click="$_showSelect('select-account')" class="select__btn"
            >选择</el-button
          >
          <div class="input-tips">*必选, 单选</div>
        </el-form-item>

        <el-form-item label="选择系统:" prop="systemName">
          <el-input
            v-model="formData.systemName"
            disabled
            placeholder="必选"
            class="form-item__input"
          ></el-input>
          <el-button @click="$_showSelect('select-system')" class="select__btn"
            >选择</el-button
          >
          <div class="input-tips">*必选, 单选</div>
          <div class="error-text">
            注意：无数据权限的应用系统不可批量配置，如需配置权限请手动添加！
          </div>
        </el-form-item>

        <el-form-item label="账号所属运营商:" prop="platformList">
          <div class="form-content">
            <el-input
              :value="
                formData.platformList
                  .reduce((prev, curr) => prev.concat([curr.platformName]), [])
                  .join(', ')
              "
              type="textarea"
              resize="none"
              disabled
              placeholder="必选, 多选"
              class="form-item__textarea"
            ></el-input>
            <el-button
              @click="$_showSelect('select-platforms')"
              class="select__btn"
              >选择</el-button
            >
            <div class="input-tips v-top">*必填, 账号所属的运营商</div>
          </div>
          <div class="error-text">
            注意：自定义组织运营商不可批量配置，如需配置权限请手动添加！
          </div>
        </el-form-item>

        <el-form-item label="账号所属品牌:">
          <el-input
            :value="
              formData.brandList
                .reduce((prev, curr) => prev.concat([curr.brandName]), [])
                .join(', ')
            "
            type="textarea"
            resize="none"
            disabled
            placeholder="请选择"
            class="form-item__textarea"
          ></el-input>
          <el-button @click="$_showSelect('select-brands')" class="select__btn"
            >选择</el-button
          >
          <div class="input-tips v-top">
            *选填, 可多选, 品牌为空即配置所选运营商
          </div>
        </el-form-item>

        <el-form-item label="账号所属门店:">
          <el-input
            :value="
              formData.shopList
                .reduce((prev, curr) => prev.concat([curr.storeName]), [])
                .join(', ')
            "
            type="textarea"
            resize="none"
            disabled
            placeholder="请选择"
            class="form-item__textarea"
          ></el-input>
          <el-button @click="$_showSelect('select-stores')" class="select__btn"
            >选择</el-button
          >
          <div class="input-tips v-top">*选填, 可多选</div>
        </el-form-item>

        <el-form-item label="选择角色:" prop="roleName">
          <el-input
            v-model="formData.roleName"
            disabled
            placeholder="必选, 选中的角色对应其功能权限"
            class="form-item__input"
          ></el-input>
          <el-button @click="$_selecRole" class="select__btn">选择</el-button>
          <!-- <div class="input-tips">*必选, 单选</div> -->
        </el-form-item>

        <el-form-item label="接收结果邮箱:" prop="emails" type="textarea">
          <el-input
            v-model="formData.emails"
            type="textarea"
            resize="none"
            placeholder="必填"
            class="form-item__textarea"
          ></el-input>
          <span class="input-tips v-top"
            >*最多输入20个邮箱地址, 多个用", "隔开</span
          >
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
    </div>
    <!-- S 选择账号 弹窗 -->
    <select-account
      v-if="modal.show === true && modal.template === 'select-account'"
      :title="modal.title"
      :selected="modal.data"
      @callback="$_selectAccountCallback"
      @close="$_close"
    ></select-account>
    <!-- E 选择账号 弹窗 -->
    <!-- S 选择系统 弹窗 -->
    <select-system
      v-if="modal.show === true && modal.template === 'select-system'"
      :title="modal.title"
      :selected="modal.data"
      @callback="$_selectSystemCallback"
      @close="$_close"
    ></select-system>
    <!-- E 选择系统 弹窗 -->
    <!-- S 选择运营商s 弹窗 -->
    <select-platforms
      v-if="modal.show === true && modal.template === 'select-platforms'"
      :title="modal.title"
      :orgType="0"
      :showAllSelect="true"
      :selecteds="modal.data.platformList"
      @callback="$_selectPlatformsCallback"
      @close="$_close"
    ></select-platforms>
    <!-- E 选择运营商s 弹窗 -->
    <!-- S 选择品牌s 弹窗 -->
    <select-brands
      v-if="modal.show === true && modal.template === 'select-brands'"
      :title="modal.title"
      :selecteds="modal.data.brandList"
      :platformKeyList="modal.data.platformKeyList"
      :isSameMerchant="false"
      :isRequire="false"
      pagingMethoName="pagingBrand"
      @callback="$_selectBrandsCallback"
      @close="$_close"
    ></select-brands>
    <!-- E 选择品牌s 弹窗 -->
    <!-- S 选择门店s 弹窗 -->
    <!-- 选择门店s弹窗组件 -->
    <select-stores
      v-if="modal.show === true && modal.template === 'select-stores'"
      :title="modal.title"
      :brandIds="modal.data.brandIdList"
      :selecteds="modal.data.shopList"
      @callback="$_selectStoresCallback"
      @close="$_close"
    ></select-stores>
    <!-- E 选择门店s 弹窗 -->
    <!-- S 选择角色 弹窗 -->
    <select-role
      v-if="modal.show === true && modal.template === 'select-role'"
      :title="modal.title"
      :presetList="presetList"
      :customList="customList"
      :bindRoleId="formData.roleId"
      @submit="$_selectRoleCallback"
      @close="$_close"
    ></select-role>
    <!-- E 选择角色 弹窗 -->
  </el-dialog>
</template>

<script>
import { checkEmails } from "@/plugins/utils.js";
import SelectAccount from "@/components/modal-select-account";
import SelectSystem from "@/components/modal-select-system";
import SelectPlatforms from "@/components/modal-select-platforms";
import SelectBrands from "@/components/modal-select-brands";
import SelectStores from "./modal-select-stores";
import SelectRole from "./modal-select-role";

export default {
  name: "batch-auth",
  props: ["title"],
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        userName: "",
        userId: 0, // 用户id
        systemName: "",
        systemId: 0, // 系统id
        roleName: "",
        roleId: 0, // 角色id
        platformList: [], // 运营商信息list  { platformKey, platformName }
        brandList: [], // 品牌信息list  { platformKey, brandId, brandName }
        shopList: [], // 门店信息list  { brandId, shopId, shopName }
        emails: "", // 接收邮件邮箱
      },
      presetList: [],
      customList: [],
      modal: {
        show: false,
        title: "",
        template: "",
        data: {},
      },
      rules: {
        userName: { required: true, message: "请选择账号" },
        systemName: { required: true, message: "请选择系统" },
        platformList: { required: true, message: "请选择运营商" },
        roleName: { required: true, message: "请选择相应角色" },
        emails: [
          { required: true, message: "请输入邮箱地址" },
          {
            validator: (rule, value, callback) => {
              let { result, tips } = checkEmails(value);
              if (!result) {
                callback(new Error(tips));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    "formData.systemId"(newVal, oldVal) {
      if (oldVal) {
        this.formData.roleId = 0;
        this.formData.roleName = "";
      }
    },
    "formData.brandList"(list) {
      let brandIdList = list.reduce(
        (prev, next) => prev.concat([next.brandId]),
        []
      );
      let shopList = this.formData.shopList.filter(
        (item) => ~brandIdList.indexOf(item.brandId)
      );
      this.formData.shopList = shopList.splice(0);
    },
  },
  methods: {
    // 关闭本弹窗发起的子弹窗
    $_close() {
      this.modal.show = false;
      this.modal.title = "";
      this.modal.template = "";
      this.modal.data = {};
    },
    // 打开选择弹窗 根据key进行策略选择
    $_showSelect(key) {
      this.modal.template = key;
      let title = "",
        modalData = {};
      switch (key) {
        case "select-account":
          title = "选择账号";
          let { userId, userName } = this.formData;
          modalData = {
            userId,
            userName,
          };
          break;
        case "select-system":
          title = "选择系统";
          let { systemId, systemName } = this.formData;
          modalData = {
            systemId,
            systemName,
          };
          break;
        case "select-platforms":
          title = "选择运营商";
          let platformList = this.formData.platformList.concat([]);
          modalData = {
            platformList,
          };
          break;
        case "select-brands":
          if (this.formData.platformList.length === 0) {
            $MessageBox.alert({ content: "请先选择所属运营商!" });
            return false;
          }
          title = "选择品牌";
          let platformKeyList = this.formData.platformList.reduce(
            (prev, next) => prev.concat([next.platformKey]),
            []
          );
          let brandList = this.formData.brandList.concat([]);
          modalData = {
            platformKeyList,
            brandList,
          };
          break;
        case "select-stores":
          if (this.formData.platformList.length === 0) {
            $MessageBox.alert({ content: "请先选择所属运营商!" });
            return false;
          }
          if (this.formData.brandList.length === 0) {
            $MessageBox.alert({ content: "请先选择品牌!" });
            return false;
          }
          title = "选择门店";
          let brandIdList = this.formData.brandList.reduce(
            (prev, next) => prev.concat([next.brandId]),
            []
          );
          modalData = {
            brandIdList,
            shopList: this.formData.shopList.concat([]),
          };
          break;
        default:
          break;
      }
      this.modal.title = title;
      this.modal.data = { ...modalData };
      this.modal.show = true;
    },
    // 打开选择账号弹窗
    $_selectAccount() {
      this.modal.template = "select-account";
      this.modal.title = "选择账号";
      let { userId, userName } = this.formData;
      this.modal.data = {
        userId,
        userName,
      };
      this.modal.show = true;
    },
    // 选择账号回调
    $_selectAccountCallback(user) {
      let { uid, accountName } = user;
      this.formData.userId = uid;
      this.formData.userName = accountName;
      this.$_close();
    },
    // 打开选择系统弹窗
    $_selecSystem() {
      this.modal.template = "select-system";
      this.modal.title = "选择系统";
      let { systemId, systemName } = this.formData;
      this.modal.data = {
        systemId,
        systemName,
      };
      this.modal.show = true;
    },
    // 选择系统回调
    $_selectSystemCallback(system) {
      let { cid: systemId, systemName } = system;
      this.formData.systemId = systemId;
      this.formData.systemName = systemName;
      this.$_close();
    },
    // 选择运营商回调
    $_selectPlatformsCallback(list) {
      this.formData.platformList = list.map((item) => {
        let { platformKey, platformName } = item;
        return { platformKey, platformName };
      });

      if (this.formData.brandList.length > 0) {
        let platformKeyList = list.reduce(
          (prev, next) => prev.concat([next.platformKey]),
          []
        );

        let brandList = this.formData.brandList.filter(
          (item) => ~platformKeyList.indexOf(item.platformKey)
        );
        this.formData.brandList = brandList.splice(0);
      }
      this.$_close();
    },
    // 选择品牌弹窗回调
    $_selectBrandsCallback(list) {
      this.formData.brandList = list.concat([]);
    },
    // 选择门店弹窗回调
    $_selectStoresCallback(list) {
      this.formData.shopList = list.concat([]);
      return true;
      this.formData.shopList = list.map((item) => {
        let { brandId, shopId, storeName: shopName } = item;
        return {
          brandId,
          shopId,
          shopName,
        };
      });
    },
    // 打开选择角色弹窗 - 独立管理
    $_selecRole() {
      if (this.formData.systemId === 0) {
        $MessageBox.alert({ content: "请先选择所属系统!" });
        return false;
      }
      this.isLoading = true;
      // 先获取角色数据
      this.$service
        .post("getRolesBySystemId", {
          systemId: this.formData.systemId,
          platformKey: "paas",
          status: 1,
        })
        .then((result) => {
          if (result.$.checkResult(result, true)) {
            this.presetList = [...result.data.presetList];
            this.customList = [...result.data.customList];

            this.modal.title = "选择账号所属的角色";
            this.modal.template = "select-role";
            this.modal.show = true;
          }
          this.isLoading = false;
        });
    },
    // 选择角色弹窗回调
    $_selectRoleCallback(role) {
      this.formData.roleId = role.rid;
      this.formData.roleName = role.roleName;
      this.$_close();
    },
    // 保存 按钮
    $_submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.isLoading) return false;
          this.isLoading = true;
          // importAccountPermissions
          let {
            userId,
            systemId,
            roleId,
            platformList,
            brandList,
            shopList,
            emails,
          } = this.formData;
          let postData = {
            userId,
            systemId,
            roleId,
            platformList,
            brandList: brandList.map((item) => {
              let { platformKey, brandId, brandName } = item;
              return { platformKey, brandId, brandName };
            }),
            shopList: shopList.map((item) => {
              let { brandId, shopId, storeName: shopName } = item;
              return {
                brandId,
                shopId,
                shopName,
              };
            }),
            emails: emails.split(",").map((item) => item.trim()),
          };
          this.$service
            .post("importAccountPermissions", postData)
            .then((result) => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk: () => {
                    this.$emit("callback");
                  },
                });
              }
              this.isLoading = false;
            });
        }
      });
    },

    // 取消 按钮 - 关闭本弹窗
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
  },
  mounted() {
    this.visible = true;
  },
  components: {
    SelectAccount,
    SelectSystem,
    SelectPlatforms,
    SelectBrands,
    SelectStores,
    SelectRole,
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 20px;
  color: #535353;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.form-wrap {
  padding-left: 20px;
  .input-tips {
    display: inline-block;
    margin-left: 10px;
  }
  .form-item {
    &__input {
      width: 440px;
      height: 28px;
    }
    &__textarea {
      width: 500px;
      height: 48px;
    }
  }
  .select__btn {
    margin-left: 8px;
    vertical-align: top;
  }
  /deep/ .el-form-item[type="textarea"] .el-form-item__error {
    top: 50px;
  }
}
</style>
